import { css } from "@emotion/core";

import { Colors, Typography } from "@zapier/design-system";

import { breakpoints } from "@zapier/checkout/esm/constants";

// Centered container
export const checkoutWrapperCss = css`
  background-color: ${Colors.neutral100};
  border: 1px solid ${Colors.neutral400};
  border-radius: 5px;
  margin: 2em auto;
  max-width: 800px;
  padding: 2em;
  width: auto;
  @media screen and (max-width: ${breakpoints.desktopMin}px) {
    border: none;
    margin-top: 0;
  }
`;

// <header>
export const headerCss = css`
  margin-bottom: 1rem;

  @media screen and (max-width: ${breakpoints.mobileMax}px) {
    margin-bottom: 3rem;
  }
`;

// <h1>
export const headingCss = css`
  ${Typography.pageHeader7};
  color: ${Colors.neutral800};
  margin-top: 0;
  text-align: center;
  padding: 0;

  @media screen and (max-width: ${breakpoints.mobileMax}px) {
    ${Typography.pageHeader9};
  }
`;
